import React from "react";
import { Phone, ArrowRight, ShieldCheck } from "lucide-react";
import QuoteCTA from "./QuoteCTA";
import { BUSINESS } from "../data/business";

export default function PreFooterCTA({
  title = "Need a drain or sewer pro you can trust?",
  subtitle = "Call or request a free quote. Drain & sewer crews serving the Baltimore and DC metros.",
}) {
  return (
    <section className="abc-prefooter text-white" data-testid="prefooter-cta">
      <div className="abc-container py-12 md:py-16 grid lg:grid-cols-2 gap-10 items-center">
        <div>
          <div className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-[#E31D2B] mb-4">
            <ShieldCheck className="w-4 h-4" /> Licensed · Insured · Local
          </div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold leading-tight">{title}</h2>
          <p className="mt-4 text-white/75 text-base md:text-lg max-w-xl">{subtitle}</p>
        </div>
        <div className="flex flex-col sm:flex-row gap-3 lg:justify-end">
          <a href={BUSINESS.phoneHref} className="abc-btn abc-btn-accent text-base py-4 px-6" data-testid="prefooter-call">
            <Phone className="w-5 h-5" /> Call {BUSINESS.phone}
          </a>
          <QuoteCTA className="abc-btn abc-btn-ghost-light text-base py-4 px-6" data-testid="prefooter-quote">
            Get a Free Quote <ArrowRight className="w-5 h-5" />
          </QuoteCTA>
        </div>
      </div>
    </section>
  );
}
